@if (tariffsForm) {
  <form [formGroup]="tariffsForm" style="margin-left: 1.5rem; margin-top: 1.5rem">
    <div class="flex flex-col">
      <h5 style="margin-bottom: 1rem">Before</h5>
      <div class="flex justify-between items-center tariff-form">
        <mat-form-field appearance="outline" class="supply">
          <mat-label>Supply</mat-label>
          <mat-select class="custom-select" id="supplyBefore" formControlName="supplyBefore" (change)="setDirtyForm()">
            <mat-option [value]="null">None</mat-option>
            <mat-option *ngFor="let supplyTariff of utilityTariffs?.supply"
                        [value]="supplyTariff.code">{{ supplyTariff.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="delivery">
          <mat-label>Delivery</mat-label>
          <mat-select class="custom-select" id="deliveryBefore" formControlName="deliveryBefore"
                      (change)="setDirtyForm()">
            <mat-option [value]="null">Not yet configured</mat-option>
            <mat-option *ngFor="let deliveryTariff of utilityTariffs?.delivery"
                        [value]="deliveryTariff.code">{{ deliveryTariff.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="flex flex-col">
      <h5 style="margin-bottom: 1rem">After</h5>
      <div class="flex justify-between items-center tariff-form">
        <mat-form-field class="supply" appearance="outline">
          <mat-label>Supply</mat-label>
          <mat-select class="custom-select" id="supplyAfter" formControlName="supplyAfter" (change)="setDirtyForm()">
            <mat-option [value]="null">None</mat-option>
            <mat-option *ngFor="let supplyTariff of utilityTariffs?.supply"
                        [value]="supplyTariff.code">{{ supplyTariff.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Delivery</mat-label>
          <mat-select class="custom-select" id="deliveryAfter" formControlName="deliveryAfter"
                      (change)="setDirtyForm()">
            <mat-option [value]="null">Not yet configured</mat-option>
            <mat-option *ngFor="let deliveryTariff of utilityTariffs?.delivery"
                        [value]="deliveryTariff.code">{{ deliveryTariff.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row form-group">
      <table class="table table-borderless table-responsive-sm">
        <tbody>
        <tr>
          <td>
            <mat-form-field appearance="outline">
              <mat-label for="supplyCharge" class="font-weight-bold">Supply Charge ($/kWh)</mat-label>
              <input matInput type="number" class="form-control" formControlName="supplyCharge" id="supplyCharge"
                     placeholder="0.00" [attr.disabled]="!hasCustomSupplyRateSet() ? '' : null" />
            </mat-form-field>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="flex items-center justify-end">
      <button mat-flat-button color="primary" (click)="save()" [disabled]="!tariffsForm.dirty || !deliveryTariffsSet()"
              style="margin-right: 0.5rem">Save
      </button>
      <button mat-flat-button color="warn" (click)="cancel()" [disabled]="!tariffsForm.dirty">Cancel</button>
    </div>
  </form>
}
